/**
 * The silent alarm, as the desk reads and clears it.
 */

import { request, type Schema } from '@taxi/api-client';

export type Alarm = Schema<'AlarmView'>;

export const alarmsApi = {
  open: () => request<Alarm[]>('/api/dispatch/alarms'),

  clear: (alarmId: string) =>
    request<Alarm>(`/api/dispatch/alarms/${alarmId}/clear`, { method: 'POST' }),
};
